module.exports = __webpack_public_path__ + "img/wdgc.6ef1396b.jpg";